<template>
  <div
    class="app-main-content"
    type="primary"
  >
    <div class="grid-view">
      <div class="main-content">
        <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
            <el-input v-model="search.jobNo" no="jobNo" style="width: 210px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_OperationProvince')">
            <cargo-advance-select
              no="opProvince"
              :select-type="TYPE_NAMES.basic_data_Office"
              filterable
              :default-value="Number(search.opProvince)"
              :cache="false"
              :static-options="provinceList"
              :placeholder="' '"
              style="width: 210px"
              @parentCallBack="p=>{search.opProvince=p.value;}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_OperationCompany')">
            <cargo-advance-select
              no="opOffice"
              :select-type="TYPE_NAMES.basic_data_Office"
              filterable
              :default-value="Number(search.opOffice)"
              :cache="false"
              :static-options="officeList"
              :placeholder="' '"
              style="width: 210px"
              @parentCallBack="p=>{search.opOffice=p.value;reSetOp()}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_OperationDepartment')">
            <cargo-department-select
              no="opDepartment"
              :office-id="Number(search.opOffice) || $store.getters.currentOfficeId"
              :department-id="Number(search.opDepartment)"
              :placeholder="' '"
              style="width: 210px"
              @change="p=>{search.opDepartment=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Operation')">
            <cargo-user-select
              no="opId"
              :method-params="{officeId:search.opOffice || $store.getters.currentOfficeId,category:'role',shape:'op'}"
              :default-value="search.opId||''"
              :placeholder="' '"
              style="width: 210px"
              @change="p=>{search.opId=p.value;}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SalesProvince')">
            <cargo-advance-select
              no="salesProvince"
              :select-type="TYPE_NAMES.basic_data_Office"
              filterable
              :default-value="Number(search.salesProvince)"
              :cache="false"
              :static-options="provinceList"
              :placeholder="' '"
              style="width: 210px"
              @parentCallBack="p=>{search.salesProvince=p.value;}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SalesCompany')">
            <cargo-advance-select
              no="salesOffice"
              :select-type="TYPE_NAMES.basic_data_Office"
              filterable
              :default-value="Number(search.salesOffice)"
              :cache="false"
              :static-options="officeList"
              :placeholder="' '"
              style="width: 210px"
              @parentCallBack="p=>{search.salesOffice=p.value;reSetSales()}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SalesDepartment')">
            <cargo-department-select
              no="salesDept"
              :office-id="Number(search.salesOffice) || $store.getters.currentOfficeId"
              :department-id="Number(search.salesDept)"
              :placeholder="' '"
              style="width: 210px"
              @change="p=>{search.salesDept=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Sales')">
            <cargo-user-select
              no="salesId"
              :method-params="{officeId:search.salesOffice || $store.getters.currentOfficeId,category:'role',shape:'sales'}"
              :default-value="search.salesId||''"
              :placeholder="' '"
              style="width: 210px"
              @change="p=>{search.salesId=p.value;}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BLNo')">
            <el-input v-model="search.mbl" no="mbl" style="width: 210px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PushTime')">
            <el-date-picker
              v-model="search.pushTimeStart"
              no="pushTimeStart"
              style="width:173px "
              value-format="yyyy-MM-dd"
              :placeholder="$t('SystemMonitor.StartDate')"
            />
            <span style="color:#dfe4ed;padding:0 4px">—</span>
            <el-date-picker
              v-model="search.pushTimeEnd"
              no="pushTimeEnd"
              style="width:173px "
              value-format="yyyy-MM-dd"
              :placeholder="$t('SystemMonitor.EndDate')"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ETD')">
            <el-date-picker
              v-model="search.etdStart"
              no="etdStart"
              style="width:173px "
              value-format="yyyy-MM-dd"
              :placeholder="$t('SystemMonitor.StartDate')"
            />
            <span style="color:#dfe4ed;padding:0 4px">—</span>
            <el-date-picker
              v-model="search.etdEnd"
              no="etdEnd"
              style="width:173px "
              value-format="yyyy-MM-dd"
              :placeholder="$t('SystemMonitor.EndDate')"
            />
          </el-form-item>
          <el-form-item style="display: block">
            <el-button size="mini" type="primary" @click="fetchList">{{ $t('common.btn.query') }}</el-button>
          </el-form-item>
        </el-form>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="250005"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="search.total>0"
            config-module="250005"
            :total="search.total"
            :page.sync="search.pageNum"
            :limit.sync="search.pageSize"
            @pagination="fetchList"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { queryCheckRuleResults } from '@/api/booking/job'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'

export default {
  name: 'CheckRuleResults',
  components: { cargoAdvanceSelect, cargoDepartmentSelect, cargoUserSelect },
  data() {
    return {
      TYPE_NAMES,
      search: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 20,
        jobNo: '',
        opProvince: 0,
        opOffice: 0,
        opDepartment: 0,
        opId: 0,
        salesProvince: 0,
        salesOffice: 0,
        salesDept: 0,
        salesId: 0,
        mbl: '',
        pushTimeStart: '',
        pushTimeEnd: '',
        etdStart: '',
        etdEnd: ''
      },
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressRowClickSelection: false,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      rowData: [],
      officeList: [],
      provinceList: []
    }
  },
  computed: {
    columnDefs() {
      return [
        { headerName: this.$t('SystemMonitor.SerialNumber'), field: 'uuid', initialWidth: 150, minWidth: 150 },
        { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'jobNo', initialWidth: 140, minWidth: 140 },
        { headerName: this.$t('CargoMsg.Cargo_BLNo'), field: 'mbl', initialWidth: 120, minWidth: 120 },
        { headerName: this.$t('CargoMsg.Cargo_OperationProvince'), field: 'opProvince', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperationCompany'), field: 'opOffice', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OperationDepartment'), field: 'opDepartment', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'opId', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesProvince'), field: 'salesProvince', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesCompany'), field: 'salesOffice', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesDepartment'), field: 'salesDept', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'salesId', initialWidth: 100, minWidth: 100,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          }
        },
        { headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerId', initialWidth: 160, minWidth: 160,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          }
        },
        { headerName: this.$t('Partners.customerCode'), field: 'customerCode', initialWidth: 100, minWidth: 100 },
        { headerName: this.$t('CargoMsg.Cargo_PushTime'), field: 'pushTime', initialWidth: 140, minWidth: 140,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PushMessage'), field: 'pushMessage', pushMessage: 160, minWidth: 160 }
      ]
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await this.init()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (this.$store.getters.currentOffice.code === 'HQ') {
        this.officeList = [...getCacheListByKey(TYPE_NAMES.basic_data_Office_All)]
      } else {
        this.officeList = this.getChildOffices(this.$store.getters.currentOfficeUuid)
        if (this.officeList.length > 0) {
          this.officeList.sort((office1, office2) => office1.code - office2.code)
        }
      }
      this.provinceList = this.initProvinces()
      if (this.provinceList.length > 0) {
        this.provinceList.sort((office1, office2) => office1.code - office2.code)
      }
    },
    reSetOp() {
      this.search.opDepartment = 0
      this.search.opId = 0
    },
    reSetSales() {
      this.search.salesDept = 0
      this.search.salesId = 0
    },
    fetchList() {
      this.search.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryCheckRuleResults({ ...this.search }).then(res => {
        this.search.pageNum = res.data.pageNum
        this.search.pageSize = res.data.pageSize
        this.search.total = Number(res.data.total)
        this.rowData = res.data.list
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 当前及下级分公司
    getChildOffices(officeUuid) {
      const allOffice = [...getCacheListByKey(TYPE_NAMES.basic_data_Office_All)]
      allOffice.sort((a, b) => a.level - b.level)
      const keySet = new Set([officeUuid])
      const offices = []
      for (const office of allOffice) {
        if (keySet.has(office.uuid)) {
          offices.push(office)
        } else if (office.parentBranchUuid && keySet.has(office.parentBranchUuid)) {
          keySet.add(office.uuid)
          offices.push(office)
        }
      }
      return offices
    },
    // 省
    initProvinces() {
      let offices = []
      if (this.$store.getters.currentOffice.level === 2) { // 当前省
        offices.push(this.$store.getters.currentOffice)
      } else {
        const allOffice = [...getCacheListByKey(TYPE_NAMES.basic_data_Office_All)]
        if (this.$store.getters.currentOffice.level < 2) { // 所有省
          offices = allOffice.filter(p => p.level === 2)
        } else { // 所在省
          const province = this.getProvinceByParentUuid(this.$store.getters.currentOffice.parentBranchUuid, allOffice)
          if (province) {
            offices.push(province)
          }
        }
      }
      return offices
    },
    // 获取公司所在省: LEVEL=2
    getProvinceByParentUuid(parentUuid, officeList) {
      if (parentUuid) {
        const offices = officeList.filter(p => parentUuid === p.uuid)
        if (offices.length > 0) {
          const office = offices[0]
          if (office.level > 2 && office.parentBranchUuid) {
            return this.getProvinceByParentUuid(office.parentBranchUuid, officeList)
          } else if (office.level === 2) {
            return office
          }
        }
      }
      return null
    }
  }
}
</script>
